
import {
    TOGGLE_SIDE_BAR,
    SET_INVISIBLE_SIDE_BAR,
    SET_VISIBLE_SIDE_BAR
} from "./../mutations.type"
import { HIDE_SIDE_BAR, SHOW_SIDE_BAR } from "../actions.type";

const state = {
    showSideBar: false
}

const getters = {
    sideBar: () => state.showSideBar
}

const actions = {
    [HIDE_SIDE_BAR](context){
        context.commit(SET_INVISIBLE_SIDE_BAR);
    },
    [SHOW_SIDE_BAR](context){
        context.commit(SET_VISIBLE_SIDE_BAR);
    }
}

const mutations = {
    [SET_INVISIBLE_SIDE_BAR](state) {
        state.showSideBar = false;
    },
    [SET_VISIBLE_SIDE_BAR](state) {
        state.showSideBar = true;
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}